import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { GetGraphByUserId } from '../../../reduxToolkit/Graphs/GraphsApi';
import { toast } from 'react-toastify';
import { DeleteItemsApi } from '../../../reduxToolkit/Commons/CommonsApi';
import { errorMsg } from '../../../Apis/functions';
import DeleteModal from '../../Modals/DeleteModal';
import { TABLES } from '../../../Apis/Tables';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const DeleteChartModal = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    /**
     * Handles chart deletion.
     * Sends request to delete the chart and updates the dashboard upon success.
     */
    const handleDelete = () => {
        const table = TABLES.CHART_DASHBOARD_POSITION;
        const body = [props.chartId];
        dispatch(DeleteItemsApi({ tableName: table, body })).then(
            ({
                payload: {
                    data: { success, code },
                },
            }) => {
                if (success === true) {
                    toast.success(t('has_been_deleted_successfully'));
                    dispatch(GetGraphByUserId(props.userId)).then(() => {
                        props.onHide();
                    });
                } else errorMsg(code);
            },
        );
    };

    return (
        <DeleteModal
            show={props.show}
            onHide={props.onHide}
            onClickFn={handleDelete}
            data={[props.chartId]}
            title_modal={'delete'}
            element_modal={'graph'}
        />
    );
};

export default DeleteChartModal;
